module.exports = __webpack_public_path__ + "img/bubbelsortering.59f8c430.jpg";